import React from 'react';
import {Alert, Col} from 'reactstrap';
import check from '../assets/images/check.png';
import VISA from '../assets/images/payments/visa.png'
import americanExpress from '../assets/images/payments/american-ex.png'
import discover from '../assets/images/payments/discover.png'
import MasterCard from '../assets/images/payments/master-card.png'
import {useSelector} from 'react-redux';
import { isDiscoverCardType } from '../modules/paymentMethods/utils/creditCardTypeResolve';

function cardBrandImage(ccTypeId, ccType) {
  const type = ccType || '';
  if (Number(ccTypeId) === 4 || type === 'VISA') return VISA;
  if (Number(ccTypeId) === 3 || type === 'Master Card' || type === 'MasterCard') return MasterCard;
  if (isDiscoverCardType(type)) return discover;
  if (type === 'American Express') return americanExpress;
  return null;
}

const AutoPayConfirmation = () => {

  const CCData = useSelector(state => state.paymentMethods);
  const {saveName, ccExpMonth, ccExpYear, ccTypeId, ccType, ccNum} = CCData.cardPaymentMethod;
  const brandImage = cardBrandImage(ccTypeId, ccType);

  return (
    <>
      <div className="d-flex justify-content-center align-items-center mt-100" style={{minHeight: '100vh'}}>
        <section className="section mt-100 ">
          <div className="rounded shadow-lg p-4 position-relative">
            <Alert color="info" className="text-center ">
              <p className="m-2"><img src={check} alt=""/></p>
              <h3>Payment Method Submitted Successfully</h3>
            </Alert>
            <Col className="col-12 m-5">
              <h5>Saved as {saveName}</h5>
              <h5>
                {brandImage ? <img src={brandImage} alt="cc type"/> : 'Credit Card: '}
                {ccNum ? `********${ccNum.slice(-4)}` : ''}</h5>
              <h5>Exp: {ccExpMonth}/{ccExpYear}</h5>
            </Col>
            <Col className="d-flex justify-content-center">
              <h4>This payment method will be used in our new system</h4>
            </Col>
          </div>

        </section>
      </div>
    </>
  );
};


export default AutoPayConfirmation;
